<div>
  <h1>{{ translationService.getGeneralProductOverviewText() }}</h1>
  <form [formGroup]="overviewForm">
    <div class="custom-form-row">
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{ translationService.getProductNameText() }}</mat-label>
        <input matInput name="name" formControlName="name" autocomplete="off" />
      </mat-form-field>

      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{
          translationService.getProductIdentifierText()
        }}</mat-label>
        <input
          matInput
          name="primaryArticleIdentifier"
          autocomplete="off"
          formControlName="primaryArticleIdentifier"
        />
      </mat-form-field>
    </div>

    <div class="custom-form-row">
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{
          translationService.getEnglishShortNameText()
        }}</mat-label>
        <input
          matInput
          name="englishShortName"
          formControlName="englishShortName"
          autocomplete="off"
          maxlength="12"
        />
      </mat-form-field>

      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{ translationService.getFrenchShortNameText() }}</mat-label>
        <input
          matInput
          name="frenchShortName"
          autocomplete="off"
          formControlName="frenchShortName"
          maxlength="12"
        />
      </mat-form-field>
    </div>

    <div class="custom-form-row">
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{
          translationService.getOtherProductNamesText()
        }}</mat-label>
        <input matInput autocomplete="off" formControlName="otherNames" />
      </mat-form-field>
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{ translationService.getGs1IdentifierText() }}</mat-label>
        <input
          name="gs1Identifier"
          matInput
          autocomplete="off"
          formControlName="gs1Identifier"
        />
      </mat-form-field>
    </div>

    <div class="custom-form-row product-picture-row">
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{
          translationService.getProducedInCanadaText()
        }}</mat-label>
        <mat-select formControlName="productionInCanada">
          <mat-option value="true">{{
            translationService.getYesText()
          }}</mat-option>
          <mat-option value="false">{{
            translationService.getNoText()
          }}</mat-option>
          <mat-option value="null">{{
            translationService.getUnwillingToDiscloseText()
          }}</mat-option>
        </mat-select>
      </mat-form-field>
      <div
        class="input-md picture-upload"
        appearance="outline"
        [attr.aria-busy]="pictureProcessing()"
      >
        <mat-label>{{ translationService.getPictureText() }}</mat-label>
        <p id="product-picture-help" class="picture-upload-help">
          {{ translationService.getProductImageUploadHelpText() }}
        </p>
        <input
          type="file"
          name="picture"
          [disabled]="pictureProcessing()"
          aria-describedby="product-picture-help"
          #pictureFile
          accept="image/png, image/jpg, image/jpeg"
          (change)="handleFileSelection($event, 'picture')"
        />

        @if (pictureProcessing()) {
          <p role="status">{{ translationService.getPreparingPhotoText() }}</p>
        }
        @if (productImageBase64) {
          <div class="picture-preview">
            <img
              [alt]="translationService.getPictureText()"
              [src]="productImageBase64"
            />
          </div>
        } @else {
          <div class="picture-placeholder">
            <mat-icon class="picture-placeholder-icon">photo</mat-icon>
            <span>{{ translationService.getProductImageNotAvailable() }}</span>
          </div>
        }
      </div>
    </div>
    <div class="custom-form-row">
      <mat-form-field appearance="outline" class="input-md">
        <mat-label>{{ translationService.getProductCategoryText() }}</mat-label>
        <mat-chip-grid #chipGrid>
          @for (category of selectedCategories(); track category.id) {
            <mat-chip-row (removed)="removeCategory(category)">
              {{ category.code }}...
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          }
        </mat-chip-grid>
        <input
          [placeholder]="translationService.getSearchCategoriesText()"
          #categoryInput
          [formControl]="categoryCtrl"
          [matChipInputFor]="chipGrid"
          [matAutocomplete]="auto"
        />
        <button
          matSuffix
          color="accent"
          id="find-product-category-btn"
          class="action-item remove-btn"
          mat-raised-button
          (click)="showExternalHSCodeTool()"
        >
          <mat-icon>search</mat-icon>
          {{ translationService.getFindCategoryText() }}
        </button>
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="selected($event)"
        >
          @for (category of filteredCategories | async; track category) {
            <mat-option [value]="category" [matTooltip]="category.name">
              <span [innerHTML]="category.displayName"></span>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{ translationService.getCategoryCodeText() }}</mat-label>
        <input
          name="categoryCode"
          matInput
          autocomplete="off"
          formControlName="categoryCode"
        />
      </mat-form-field>
    </div>
    <div class="custom-form-row">
      <mat-form-field class="input-lg" appearance="outline">
        <mat-label>{{ translationService.getProductTypeText() }}</mat-label>
        <input name="type" matInput autocomplete="off" formControlName="type" />
      </mat-form-field>
      <mat-form-field class="input-lg" appearance="outline">
        <mat-label>{{
          translationService.getEUProductCategoryText()
        }}</mat-label>
        <input
          name="articleCategory"
          matInput
          autocomplete="off"
          formControlName="articleCategory"
        />
      </mat-form-field>
    </div>
    <div class="custom-form-row">
      <mat-form-field class="input-lg" appearance="outline">
        <mat-label>{{ translationService.getBrandText() }}</mat-label>
        <input
          name="brand"
          matInput
          autocomplete="off"
          formControlName="brand"
        />
      </mat-form-field>
      <mat-form-field class="input-lg" appearance="outline">
        <mat-label>{{ translationService.getCodeDescriptionText() }}</mat-label>
        <input
          name="codeDescription"
          matInput
          autocomplete="off"
          formControlName="codeDescription"
        />
      </mat-form-field>
    </div>

    <h2>{{ translationService.getMarketplaceDetailsText() }}</h2>
    <div class="marketplace-controls">
      @if (editing && clonedData?.isCopiedFromSupplier) {
        <p>{{ translationService.getSupplierCopyMarketplaceNoticeText() }}</p>
      } @else {
        <mat-checkbox formControlName="isMarketplacePrivate">{{
          translationService.getKeepProductPrivateText()
        }}</mat-checkbox>
        <mat-checkbox formControlName="allowRequests">{{
          translationService.getAllowRequestsText()
        }}</mat-checkbox>
        <p>{{ translationService.getMarketplaceSettingsHelpText() }}</p>
      }
    </div>
    <div class="custom-form-row">
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{
          translationService.getMarketplaceCategoryLabelText()
        }}</mat-label>
        <mat-select
          formControlName="marketplaceCategory"
          (selectionChange)="onMarketplaceCategoryChange()"
        >
          @if (editing) {
            <mat-option [value]="null">{{
              translationService.getMarketplaceUncategorizedText()
            }}</mat-option>
          }
          @for (category of marketplaceCategories; track category.name) {
            <mat-option [value]="category.name">{{
              translationService.getMarketplaceCategoryText(category.name)
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{
          translationService.getMarketplaceSubcategoryLabelText()
        }}</mat-label>
        <mat-select formControlName="marketplaceSubcategory">
          <mat-option [value]="null">{{
            translationService.getMarketplaceUnknownText()
          }}</mat-option>
          @for (subcategory of marketplaceSubcategories; track subcategory) {
            <mat-option [value]="subcategory">{{
              translationService.getMarketplaceSubcategoryText(subcategory)
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="custom-form-row">
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{
          translationService.getMarketplaceRequestUnitText()
        }}</mat-label>
        <input
          matInput
          formControlName="requestUnit"
          [matAutocomplete]="requestUnitOptions"
          autocomplete="off"
        />
        <mat-autocomplete
          #requestUnitOptions="matAutocomplete"
          [displayWith]="displayRequestUnit"
        >
          @for (unit of requestUnits; track unit) {
            <mat-option [value]="unit">{{
              translationService.getMarketplaceRequestUnitValueText(unit)
            }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{
          translationService.getMarketplaceConditionText()
        }}</mat-label>
        <mat-select formControlName="condition">
          <mat-option [value]="null">—</mat-option>
          @for (condition of productConditions; track condition) {
            <mat-option [value]="condition">{{
              translationService.getMarketplaceConditionValueText(condition)
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="custom-form-row">
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{
          translationService.getMarketplacePricePerUnitText()
        }}</mat-label>
        <input
          matInput
          type="number"
          min="0"
          formControlName="priceAmount"
          [required]="!editing"
        />
        @if (overviewForm.get('priceAmount')?.invalid) {
          <mat-error>{{
            translationService.getMarketplacePositivePriceText()
          }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{
          translationService.getMarketplaceCurrencyText()
        }}</mat-label>
        <mat-select
          formControlName="priceCurrency"
          [required]="
            !editing || overviewForm.controls.priceAmount.value !== null
          "
        >
          <mat-select-trigger>{{
            overviewForm.value.priceCurrency
          }}</mat-select-trigger>
          <mat-option [value]="null">—</mat-option>
          @for (
            currency of currencyOptions(overviewForm.value.priceCurrency);
            track currency.code
          ) {
            <mat-option [value]="currency.code"
              >{{ currency.code }} · {{ currency.name }}</mat-option
            >
          }
        </mat-select>
        @if (overviewForm.get('priceCurrency')?.invalid) {
          <mat-error>{{
            translationService.getMarketplaceCurrencyRequiredText()
          }}</mat-error>
        }
      </mat-form-field>
    </div>
    @if (overviewForm.value.marketplaceCategory === 'Drones') {
      <div class="custom-form-row">
        <mat-form-field class="input-md" appearance="outline">
          <mat-label>{{
            translationService.getMarketplaceFlightTimeMinutesText()
          }}</mat-label>
          <input
            matInput
            type="number"
            min="0"
            formControlName="droneFlightTimeMinutes"
          />
          @if (
            overviewForm.get('droneFlightTimeMinutes')?.hasError('positive')
          ) {
            <mat-error>{{
              translationService.getMarketplacePositiveFlightTimeText()
            }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="input-md" appearance="outline">
          <mat-label>{{
            translationService.getMarketplaceDroneTypeText()
          }}</mat-label>
          <input matInput formControlName="droneType" autocomplete="off" />
        </mat-form-field>
      </div>
      <div class="custom-form-row">
        <mat-form-field class="input-md" appearance="outline">
          <mat-label>{{
            translationService.getMarketplaceVideoResolutionText()
          }}</mat-label>
          <input
            matInput
            formControlName="droneVideoResolution"
            autocomplete="off"
          />
        </mat-form-field>
        <mat-form-field class="input-md" appearance="outline">
          <mat-label>{{
            translationService.getMarketplaceSensorSizeInchesText()
          }}</mat-label>
          <input
            matInput
            formControlName="droneSensorSize"
            autocomplete="off"
          />
        </mat-form-field>
        <mat-form-field class="input-md" appearance="outline">
          <mat-label>{{
            translationService.getMarketplaceFpvText()
          }}</mat-label>
          <mat-select formControlName="droneFpv">
            <mat-option [value]="null">{{
              translationService.getMarketplaceUnknownText()
            }}</mat-option>
            <mat-option [value]="true">{{
              translationService.getYesText()
            }}</mat-option>
            <mat-option [value]="false">{{
              translationService.getNoText()
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    }

    <div class="custom-form-row">
      <mat-form-field class="input-sm" appearance="outline">
        <mat-label>{{
          translationService.getBarcodeIdentifierText()
        }}</mat-label>
        <input
          name="barcodeIdentifier"
          matInput
          autocomplete="off"
          formControlName="barcodeIdentifier"
        />
      </mat-form-field>

      <mat-form-field class="input-sm" appearance="outline">
        <mat-label>{{ translationService.getSKUText() }}</mat-label>
        <input matInput name="sku" formControlName="sku" autocomplete="off" />
      </mat-form-field>
      <mat-form-field class="input-sm" appearance="outline">
        <mat-label>{{ translationService.getLowerBatchRangeText() }}</mat-label>
        <input
          matInput
          name="batch"
          formControlName="batch"
          autocomplete="off"
        />
      </mat-form-field>
      <mat-form-field class="input-sm" appearance="outline">
        <mat-label>{{ translationService.getUpperBatchRangeText() }}</mat-label>
        <input
          matInput
          name="batch_upper"
          formControlName="batch_upper"
          autocomplete="off"
        />
      </mat-form-field>
    </div>
    <div class="custom-form-row">
      <mat-form-field class="input-sm" appearance="outline">
        <mat-label>{{
          translationService.getLowerSerialRangeText()
        }}</mat-label>
        <input
          matInput
          name="serial"
          formControlName="serial"
          autocomplete="off"
        />
      </mat-form-field>
      <mat-form-field class="input-sm" appearance="outline">
        <mat-label>{{
          translationService.getUpperSerialRangeText()
        }}</mat-label>
        <input
          matInput
          name="serial_upper"
          formControlName="serial_upper"
          autocomplete="off"
        />
      </mat-form-field>
      <mat-form-field class="input-sm" appearance="outline">
        <mat-label>{{ translationService.getMeasurementUnitText() }}</mat-label>
        <mat-select formControlName="measureUnit">
          @for (type of measurementTypes; track type) {
            <mat-option [value]="type.shortName">{{ type.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-sm" appearance="outline">
        <mat-label>{{ translationService.getWeightText() }}</mat-label>
        <input
          matInput
          name="measureValue"
          formControlName="measureValue"
          autocomplete="off"
        />
      </mat-form-field>
    </div>

    <div class="custom-form-row">
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{ translationService.getDiameterText() }}</mat-label>
        <input
          matInput
          name="diameter"
          formControlName="diameter"
          autocomplete="off"
        />
      </mat-form-field>
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{ translationService.getWidthText() }}</mat-label>
        <input
          matInput
          name="width"
          formControlName="width"
          autocomplete="off"
        />
      </mat-form-field>
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{ translationService.getHeightText() }}</mat-label>
        <input
          matInput
          name="height"
          formControlName="height"
          autocomplete="off"
        />
      </mat-form-field>
    </div>

    <div class="form-section-head">
      <h2>{{ translationService.getUsageInstructionsText() }}</h2>
    </div>

    <div class="custom-form-row">
      <mat-form-field class="input-lg" appearance="outline">
        <mat-label>{{ translationService.getDescriptionText() }}</mat-label>
        <textarea
          maxlength="2042"
          rows="6"
          matInput
          name="description"
          formControlName="description"
          autocomplete="off"
        ></textarea>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="input-lg" appearance="outline">
        <mat-label>{{
          translationService.getSafeUseInstructionsText()
        }}</mat-label>
        <textarea
          maxlength="2042"
          rows="6"
          matInput
          name="safeUseInstructions"
          formControlName="safeUseInstructions"
          autocomplete="off"
        ></textarea>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="input-lg" appearance="outline">
        <mat-label>{{
          translationService.getDisassemblingInstructionsText()
        }}</mat-label>
        <textarea
          maxlength="2042"
          rows="6"
          matInput
          name="disassemblingInstructions"
          formControlName="disassemblingInstructions"
          autocomplete="off"
        ></textarea>
      </mat-form-field>
    </div>
    <div>
      <div class="input-lg" appearance="outline">
        <mat-label>{{ translationService.getSafetyDataSheetText() }}</mat-label>
        <input
          type="file"
          #safetyFile
          name="safetyDataSheet"
          accept="application/pdf"
          (change)="handleFileSelection($event, 'safetyDataSheet')"
        />
      </div>
    </div>
    <div>
      <div class="input-lg" appearance="outline">
        <mat-label>{{
          translationService.getRecyclingInstructionsText()
        }}</mat-label>
        <input
          type="file"
          #recyclingFile
          name="recyclingInstructions"
          accept="application/pdf"
          (change)="handleFileSelection($event, 'recyclingInstructions')"
        />
      </div>
    </div>
    <section class="custom-fields-section">
      <h2>{{ translationService.getCustomFieldsText() }}</h2>
      <p>{{ translationService.getCustomFieldPublicHintText() }}</p>
      <div formArrayName="customFields">
        @for (field of customFields.controls; track field; let index = $index) {
          <div
            class="custom-field-row"
            [formGroupName]="index"
            role="group"
            [attr.aria-label]="customFieldLabel(index)"
          >
            <mat-form-field appearance="outline">
              <mat-label>{{
                translationService.getCustomFieldNameText()
              }}</mat-label>
              <input
                matInput
                formControlName="name"
                (blur)="normalizeCustomFieldName(index)"
                [attr.aria-label]="
                  translationService.getCustomFieldNameText() +
                  ', ' +
                  customFieldLabel(index)
                "
                maxlength="128"
              />
              <mat-error>{{
                translationService.getCustomFieldNameErrorText()
              }}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{
                translationService.getCustomFieldTypeText()
              }}</mat-label>
              <mat-select
                formControlName="type"
                [aria-label]="
                  translationService.getCustomFieldTypeText() +
                  ', ' +
                  customFieldLabel(index)
                "
              >
                <mat-option value="text">{{
                  translationService.getCustomFieldTextText()
                }}</mat-option>
                <mat-option value="number">{{
                  translationService.getCustomFieldNumberText()
                }}</mat-option>
                <mat-option value="boolean">{{
                  translationService.getCustomFieldBooleanText()
                }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{
                translationService.getCustomFieldValueText()
              }}</mat-label>
              @if (field.controls.type.value === 'boolean') {
                <mat-select
                  formControlName="value"
                  [aria-label]="
                    translationService.getCustomFieldValueText() +
                    ', ' +
                    customFieldLabel(index)
                  "
                >
                  <mat-option [value]="true">{{
                    translationService.getYesText()
                  }}</mat-option>
                  <mat-option [value]="false">{{
                    translationService.getNoText()
                  }}</mat-option>
                </mat-select>
              } @else if (field.controls.type.value === 'number') {
                <input
                  matInput
                  type="number"
                  step="any"
                  formControlName="value"
                  [attr.aria-label]="
                    translationService.getCustomFieldValueText() +
                    ', ' +
                    customFieldLabel(index)
                  "
                />
              } @else {
                <input
                  matInput
                  formControlName="value"
                  [attr.aria-label]="
                    translationService.getCustomFieldValueText() +
                    ', ' +
                    customFieldLabel(index)
                  "
                  maxlength="2048"
                />
              }
              <mat-error>{{
                translationService.getCustomFieldValueErrorText()
              }}</mat-error>
            </mat-form-field>
            @if (field.controls.type.value === 'number') {
              <mat-form-field appearance="outline">
                <mat-label>{{
                  translationService.getCustomFieldUnitText()
                }}</mat-label>
                <input
                  matInput
                  formControlName="unit"
                  [attr.aria-label]="
                    translationService.getCustomFieldUnitText() +
                    ', ' +
                    customFieldLabel(index)
                  "
                  maxlength="64"
                />
                <mat-error>{{
                  translationService.getCustomFieldUnitErrorText()
                }}</mat-error>
              </mat-form-field>
            }
            <button
              mat-icon-button
              type="button"
              [attr.aria-label]="
                translationService.getRemoveCustomFieldText() +
                ' ' +
                customFieldLabel(index)
              "
              (click)="removeCustomField(index)"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        }
      </div>
      @if (customFields.hasError('duplicate')) {
        <p class="custom-field-error" role="alert">
          {{ translationService.getCustomFieldDuplicateErrorText() }}
        </p>
      }
      @if (customFields.hasError('limit')) {
        <p class="custom-field-error" role="alert">
          {{ translationService.getCustomFieldLimitErrorText() }}
        </p>
      }
      <button
        mat-stroked-button
        type="button"
        [disabled]="customFields.length >= 50"
        (click)="addCustomField()"
      >
        <mat-icon>add</mat-icon>{{ translationService.getAddCustomFieldText() }}
      </button>
    </section>
  </form>
  <div>
    <div class="actions margin-top-10">
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="onSubmit()"
        [disabled]="pictureProcessing()"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getNextText() }}
      </button>

      <button
        type="button"
        mat-stroked-button
        extended
        color="primary"
        class="action-item"
        (click)="onReset()"
        [disabled]="pictureProcessing()"
      >
        <mat-icon>refresh</mat-icon>
        {{ translationService.getResetText() }}
      </button>
    </div>
  </div>
</div>
